import { payment_links as paymentLinks } from '@repo/api-kit/cards-acceptance';
import { PaymentMethods } from '@repo/api-kit/queries/payment-links';

export const PAYMENT_METHODS_DISPLAY_ORDER: PaymentMethods[] = [
  PaymentMethods.CreditCard,
  PaymentMethods.ApplePay,
  PaymentMethods.Ideal,
  PaymentMethods.Paypal,
  PaymentMethods.BankTransfer,
];

export const compareDisplayOrder = (a: PaymentMethods, b: PaymentMethods): number =>
  PAYMENT_METHODS_DISPLAY_ORDER.indexOf(a) - PAYMENT_METHODS_DISPLAY_ORDER.indexOf(b);

export const V4PaymentMethod = paymentLinks.firstparty.v4.ApiPaymentMethod;

export type V4PaymentMethod = (typeof V4PaymentMethod)[keyof typeof V4PaymentMethod];
